export default __webpack_public_path__ + "static/media/Gauntlets of Black Spite.e3512589.jpg";